import { useQuery } from '@tanstack/react-query';

import * as ApiMeta from '@Api/Meta';
import { useRequest } from '@Contexts/Request';

const useUITranslation = () => {
  const request = useRequest();
  const { country, language } = request;
  const params = { lang: language.id, country };

  return useQuery({
    queryKey: ['translation', 'ui', params],
    queryFn: () => {
      return ApiMeta.getUITranslation(params, request);
    },
    enabled: true,
    placeholderData: (previousData) => previousData,
  });
};

export default useUITranslation;
